<ng-container *ngIf="!nzFormControl">
    <ng-container *ngIf="message$ | async">{{message$ | async}}</ng-container>
</ng-container>